/*
  Gulawat wishlist (saved on the shopper's device, no account needed).
  - Any button with [data-wish-toggle][data-handle] saves / removes that product (product page, product cards).
  - [data-wish-count] elements show how many pieces are saved (header heart).
  - [data-wishlist-page] renders the saved pieces (Wishlist page).
  - Stays in sync across open tabs.
*/
(function () {
  var KEY = 'gulawat:wishlist';
  var MAX = 60;

  function get() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function set(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    sync();
  }
  function has(handle) { return get().indexOf(handle) > -1; }
  function toggle(handle) {
    var list = get(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    set(list);
    return i === -1;
  }

  // Update every heart and count on the page
  function sync() {
    var list = get();
    document.querySelectorAll('[data-wish-toggle]').forEach(function (b) {
      var on = list.indexOf(b.dataset.handle) > -1;
      b.setAttribute('aria-pressed', String(on));
      var name = b.dataset.title ? ' ' + b.dataset.title : '';
      b.setAttribute('aria-label', on ? 'Remove' + name + ' from wishlist' : 'Save' + name + ' to wishlist');
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
    var link = document.querySelector('[data-wish-link]');
    if (link) link.setAttribute('aria-label', 'Wishlist, ' + list.length + (list.length === 1 ? ' piece' : ' pieces'));
  }

  // Small confirmation toast with a link to the wishlist
  var toastTimer;
  function toast(added) {
    var t = document.getElementById('GulawatWishToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'GulawatWishToast';
      t.className = 'gw-wish-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    var url = (window.GulawatWishlistUrl || '/pages/wishlist');
    t.innerHTML = added
      ? '<span>Saved to your wishlist</span><a href="' + url + '">View</a>'
      : '<span>Removed from your wishlist</span>';
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish-toggle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(b.dataset.handle);
    b.classList.remove('is-pop'); void b.offsetWidth; if (added) b.classList.add('is-pop');
    if (!b.closest('[data-wishlist-page]')) toast(added);
    if (b.closest('[data-wishlist-page]')) renderPage();
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); renderPage(); } });

  // ===== Wishlist page =====
  function money(cents, format) {
    var v = (cents / 100);
    var withDec = v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = Math.round(v).toLocaleString('en-IN');
    return (format || 'Rs. {{amount}}').replace(/\{+\s*(\w+)\s*\}+/, function (_, k) {
      return /no_decimals/.test(k) ? noDec : withDec;
    });
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  var cache = {};
  function renderPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var count = page.querySelector('[data-wishlist-count]');
    var list = get();
    if (count) count.textContent = list.length ? list.length + (list.length === 1 ? ' piece saved' : ' pieces saved') : '';
    if (!list.length) { grid.innerHTML = ''; grid.hidden = true; empty.hidden = false; return; }
    empty.hidden = true; grid.hidden = false;
    page.classList.add('is-loading');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(list.map(function (h) {
      if (cache[h]) return Promise.resolve(cache[h]);
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) cache[h] = p; return p; })
        .catch(function () { return null; });
    })).then(function (products) {
      var format = page.dataset.moneyFormat;
      var missing = [];
      grid.innerHTML = products.map(function (p, i) {
        if (!p) { missing.push(list[i]); return ''; }
        var from = p.price_varies ? 'From ' : '';
        var pre = (p.tags || []).indexOf('Pre-order') > -1 ? '<span class="gwl__tag">Pre-order</span>' : '';
        var sold = p.available ? '' : '<span class="gwl__tag gwl__tag--out">Sold out</span>';
        return '<li class="gwl__item">' +
          '<a class="gwl__media" href="' + p.url + '">' + (p.featured_image ? '<img src="' + img(p.featured_image, 600) + '" srcset="' + img(p.featured_image, 400) + ' 400w, ' + img(p.featured_image, 600) + ' 600w, ' + img(p.featured_image, 900) + ' 900w" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(p.title) + '" loading="lazy" width="600" height="800">' : '') + (sold || pre) + '</a>' +
          '<button type="button" class="gwl__remove" data-wish-toggle data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '" aria-pressed="true" aria-label="Remove ' + esc(p.title) + ' from wishlist"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" fill="none"/></svg></button>' +
          '<div class="gwl__body"><a class="gwl__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
          '<p class="gwl__price">' + from + money(p.price_min || p.price, format) + '</p>' +
          '<a class="gwl__btn" href="' + p.url + '">' + (p.available ? 'Choose options' : 'View piece') + '</a></div></li>';
      }).join('');
      // Forget pieces that no longer exist in the store
      if (missing.length) set(get().filter(function (h) { return missing.indexOf(h) === -1; }));
      page.classList.remove('is-loading');
      sync();
    });
  }

  function init() { sync(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Sections re-rendered in the theme editor or by cart updates
  document.addEventListener('shopify:section:load', init);

  window.GulawatWishlist = { get: get, has: has, toggle: toggle, sync: sync };
})();
